export default __webpack_public_path__ + "static/media/liquidlaunch.1cb5921a.png";